<template>
  <Layout id="app" class="layout">
    <Affix class="affix-header" v-fix="$route.meta.headfixed">
      <Header :style="{background: $route.meta.headfixed ? 'rgba(0, 0, 0, 0.6)': ''}" />
    </Affix>
    <Modal :mask-closable="false" v-model="user.doEntry" @on-cancel="$route.params.to = null" width="500" class="user-modal">
      <component v-if="!$store.getters.isLogined || user.doEntry" v-model="user.doEntry" :params="user.params" :is="user.entry"></component>
    </Modal>
    <Modal v-model="$store.state.showInquiry" width="500" class="inquiry-modal" :footer-hide="true">
      <img class="inquiryImg" alt="ADRAYN" :src="$ComDomain.base + 'static/images/inquiry.jpg'">
      <p class="label">
        客服热线
      </p>
      <p class="tel">
        010-52167830
      </p>
    </Modal>
    <OpenShop v-model="openShopModal"></OpenShop>
    <router-view class="content" />
    <Footer v-show="!contentLoading" />
    <AffixFuns v-if="roleName == 'personal'" />
  </Layout>
</template>

<script>
import { mapState } from 'vuex';
import { Affix, Layout, Modal } from 'iview';
import { Header, Footer, AffixFuns } from '@/commons';
import { vFix } from '@/plugins/Directives';

import 'commons/style';
import 'assets/css/styles';

export default {
  name: 'Index',
  data () {
    return {
      loading: true
    };
  },
  computed: mapState(['contentLoading', 'user', 'roleName', 'openShopModal']),
  watch: {
    $route (to, from) {
      this.$store.commit('scroll');
    }
  },
  mounted () {
    this.loading = false;
  },
  directives: {
    fix: vFix
  },
  components: {
    Affix,
    Layout,
    Header,
    Footer,
    AffixFuns,
    Modal,
    login (resolve) {
      require(['commons/components/login/Login'], resolve);
    },
    reg (resolve) {
      require(['commons/components/login/Reg'], resolve);
    },
    simpleReg (resolve) {
      require(['commons/components/login/SimpleReg'], resolve);
    },
    forgot (resolve) {
      require(['commons/components/login/Forgot'], resolve);
    },
    OpenShop (resolve) {
      require(['commons/components/openShop/OpenShop'], resolve);
    },
    demand (resolve) {
      require(['components/user/Demand'], resolve);
    }
  }
};
</script>

<style lang="less">
.affix-header {
  position: relative;
  z-index: 100;
}

.layout {
  min-width: 1260px;
  height: 100%;
}

.mobile .layout {
  min-width: auto;
  width: 100%;
  height: 100%;
}

.mobile {
  .affix-panel {
    display: none;
  }

  .footer {
    display: none;
  }
}

.inquiry-modal {
  width: 7.2rem !important;

  .ivu-modal-body {
    text-align: center;
  }

  .ivu-modal-content {
    padding: 0.8rem;
    border-radius: 0.133rem;
  }

  .inquiryImg {
    width: 5.733rem;
    height: 5.733rem;
  }

  .label {
    font-size: 0.427rem;
    text-align: center;
  }

  .tel {
    color: #FF8A00;
    font-size: 0.48rem;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/index.vue